export function concatAddress(address1?: string, address2?: string, city?: string, stateProvince?: string, postalCode?: string, country?: string): string {
  let str = ''

  if (address1 && city && stateProvince && postalCode) {
    str = address1
    if (address2) str += ` ${address2}`
    str += `, ${city}`
    str += `, ${stateProvince} ${postalCode}`
    if (country) str += ` ${country}`
  }

  return str
}
